export enum CheckboxStyle {
    standard = 'standard',
    slide = 'slide',
}
